import { render } from "./App.vue?vue&type=template&id=e016ed46"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e016ed46&lang=css"

import exportComponent from "/app/frontend-danahealth/dsg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__